import Airbnb from '@/views/marketmath/Airbnb.vue'
import AirbnbCrawlers from '@/views/marketmath/AirbnbCrawlers.vue'
import AirbnbCrawler from '@/views/marketmath/AirbnbCrawler.vue'
import AirbnbListings from '@/views/marketmath/AirbnbListings.vue'
import AirbnbListing from '@/views/marketmath/AirbnbListing.vue'
import AnalysisPresets from '@/views/marketmath/AnalysisPresets.vue'
import AnalysisPreset from '@/views/marketmath/AnalysisPreset.vue'
import Areas from '@/views/marketmath/Areas.vue'
import Area from '@/views/marketmath/Area.vue'
import Cities from '@/views/marketmath/Cities.vue'
import City from '@/views/marketmath/City.vue'
import Complexes from '@/views/marketmath/Complexes.vue'
import Complex from '@/views/marketmath/Complex.vue'
import Crawlers from '@/views/marketmath/Crawlers.vue'
import Crawler from '@/views/marketmath/Crawler.vue'
import Listings from '@/views/marketmath/Listings.vue'
import ListingsPending from '@/views/marketmath/ListingsPending.vue'
import Listing from '@/views/marketmath/Listing.vue'
import ListingAnalysis from '@/views/marketmath/ListingAnalysis.vue'
import Managers from '@/views/marketmath/Managers.vue'
import Manager from '@/views/marketmath/Manager.vue'
import Markets from '@/views/marketmath/Markets.vue'
import Market from '@/views/marketmath/Market.vue'
import Participants from '@/views/marketmath/Participants.vue'
import Participant from '@/views/marketmath/Participant.vue'
import Realtors from '@/views/marketmath/Realtors.vue'
import Realtor from '@/views/marketmath/Realtor.vue'
import Sponsors from '@/views/marketmath/Sponsors.vue'
import Sponsor from '@/views/marketmath/Sponsor.vue'
import Surveys from '@/views/marketmath/Surveys.vue'
import Survey from '@/views/marketmath/Survey.vue'
import SurveyResults from '@/views/marketmath/SurveyResults.vue'
import SurveyResult from '@/views/marketmath/SurveyResult.vue'
import Variances from '@/views/marketmath/Variances.vue'

import * as Breadcrumbs from '../breadcrumbs/marketmath'

export default [
	{
		path: '/markets',
		name: 'markets',
		component: Markets,
		meta: {
			requiresAuth: true,
			title: 'MarketMath',
			breadcrumb: [
				Breadcrumbs.Markets,
			],
		},
	},
	{
		path: '/markets/:market',
		name: 'market',
		component: Market,
		meta: {
			requiresAuth: true,
			title: 'MarketMath',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Market,
			],
		},
	},
	{
		path: '/markets/:market/analysispresets',
		name: 'market-analysispresets',
		component: AnalysisPresets,
		meta: {
			requiresAuth: true,
			title: 'Market Analysis Presets',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.AnalysisPresets,
			],
		},
	},
	{
		path: '/markets/:market/analysispresets/:preset',
		name: 'market-analysispreset',
		component: AnalysisPreset,
		meta: {
			requiresAuth: true,
			title: 'Market Analysis Presets',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.AnalysisPresets,
				Breadcrumbs.AnalysisPreset,
			],
		},
	},
	{
		path: '/markets/:market/areas',
		name: 'market-areas',
		component: Areas,
		meta: {
			requiresAuth: true,
			title: 'Market Areas',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Areas,
			],
		},
	},
	{
		path: '/markets/:market/areas/:area',
		name: 'market-area',
		component: Area,
		meta: {
			requiresAuth: true,
			title: 'Market Areas',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Areas,
				Breadcrumbs.Area,
			],
		},
	},
	{
		path: '/markets/:market/cities',
		name: 'market-cities',
		component: Cities,
		meta: {
			requiresAuth: true,
			title: 'Market Cities',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Cities,
			],
		},
	},
	{
		path: '/markets/:market/cities/:city',
		name: 'market-city',
		component: City,
		meta: {
			requiresAuth: true,
			title: 'Market Cities',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Cities,
				Breadcrumbs.City,
			],
		},
	},
	{
		path: '/markets/:market/complexes',
		name: 'market-complexes',
		component: Complexes,
		meta: {
			requiresAuth: true,
			title: 'Market Complexes',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Complexes,
			],
		},
	},
	{
		path: '/markets/:market/complexes/:complex',
		name: 'market-complex',
		component: Complex,
		meta: {
			requiresAuth: true,
			title: 'Market Complexes',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Complexes,
				Breadcrumbs.Complex,
			],
		},
	},
	{
		path: '/markets/:market/realtors',
		name: 'market-realtors',
		component: Realtors,
		meta: {
			requiresAuth: true,
			title: 'Market Realtors',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Realtors,
			],
		},
	},
	{
		path: '/markets/:market/realtors/:realtor',
		name: 'market-realtor',
		component: Realtor,
		meta: {
			requiresAuth: true,
			title: 'Market Realtors',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Realtors,
				Breadcrumbs.Realtor,
			],
		},
	},
	{
		path: '/markets/:market/crawlers',
		name: 'market-crawlers',
		component: Crawlers,
		meta: {
			requiresAuth: true,
			title: 'Market Crawlers',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Crawlers,
			],
		},
	},
	{
		path: '/markets/:market/crawlers/:crawler',
		name: 'market-crawler',
		component: Crawler,
		meta: {
			requiresAuth: true,
			title: 'Market Crawlers',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Crawlers,
				Breadcrumbs.Crawler,
			],
		},
	},
	{
		path: '/markets/:market/listings',
		name: 'market-listings',
		component: Listings,
		meta: {
			requiresAuth: true,
			title: 'Market Listings',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Listings,
			],
		},
	},
	{
		path: '/markets/:market/listings/pending',
		name: 'market-listings-pending',
		component: ListingsPending,
		meta: {
			requiresAuth: true,
			title: 'Market Listings',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Listings,
			],
		},
	},
	{
		path: '/markets/:market/listings/:listing',
		name: 'market-listing',
		component: Listing,
		meta: {
			requiresAuth: true,
			title: 'Market Listings',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Listings,
				Breadcrumbs.Listing,
			],
		},
	},
	{
		path: '/markets/:market/listings/:listing/analysis',
		name: 'market-listing-analysis',
		component: ListingAnalysis,
		meta: {
			requiresAuth: true,
			title: 'Market Listings',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Listings,
				Breadcrumbs.Listing,
				Breadcrumbs.ListingAnalysis,
			],
		},
	},
	{
		path: '/markets/:market/participants',
		name: 'market-participants',
		component: Participants,
		meta: {
			requiresAuth: true,
			title: 'Market Participants',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Participants,
			],
		},
	},
	{
		path: '/markets/:market/participants/:participant',
		name: 'market-participant',
		component: Participant,
		meta: {
			requiresAuth: true,
			title: 'Market Participants',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Participants,
				Breadcrumbs.Participant,
			],
		},
	},
	{
		path: '/markets/:market/surveys',
		name: 'market-surveys',
		component: Surveys,
		meta: {
			requiresAuth: true,
			title: 'Market Surveys',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Surveys,
			],
		},
	},
	{
		path: '/markets/:market/surveys/:survey',
		name: 'market-survey',
		component: Survey,
		meta: {
			requiresAuth: true,
			title: 'Market Surveys',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Surveys,
				Breadcrumbs.Survey,
			],
		},
	},
	{
		path: '/markets/:market/surveys/:survey/results',
		name: 'market-survey-results',
		component: SurveyResults,
		meta: {
			requiresAuth: true,
			title: 'Market Surveys',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Surveys,
				Breadcrumbs.SurveyResults,
			],
		},
	},
	{
		path: '/markets/:market/surveys/:survey/results/:result',
		name: 'market-survey-result',
		component: SurveyResult,
		meta: {
			requiresAuth: true,
			title: 'Market Surveys',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Surveys,
				Breadcrumbs.SurveyResults,
				Breadcrumbs.SurveyResult,
			],
		},
	},
	{
		path: '/markets/:market/variances',
		name: 'market-variances',
		component: Variances,
		meta: {
			requiresAuth: true,
			title: 'Market Variances Report',
			breadcrumb: [
				Breadcrumbs.Markets,
				Breadcrumbs.Variances,
			],
		},
	},

	{
		path: '/marketairbnb',
		name: 'market-airbnb',
		component: Airbnb,
		meta: {
			requiresAuth: true,
			title: 'MarketMath Airbnb Data',
			breadcrumb: [
				Breadcrumbs.Airbnb,
			],
		},
	},

	{
		path: '/marketairbnb/:market/crawlers',
		name: 'market-airbnb-crawlers',
		component: AirbnbCrawlers,
		meta: {
			requiresAuth: true,
			title: 'MarketMath Airbnb Data',
			breadcrumb: [
				Breadcrumbs.Airbnb,
				Breadcrumbs.AirbnbCrawlers,
			],
		},
	},

	{
		path: '/marketairbnb/:market/crawlers/:crawler',
		name: 'market-airbnb-crawler',
		component: AirbnbCrawler,
		meta: {
			requiresAuth: true,
			title: 'MarketMath Airbnb Data',
			breadcrumb: [
				Breadcrumbs.Airbnb,
				Breadcrumbs.AirbnbCrawlers,
				Breadcrumbs.AirbnbCrawler,
			],
		},
	},

	{
		path: '/marketairbnb/:market/listings',
		name: 'market-airbnb-listings',
		component: AirbnbListings,
		meta: {
			requiresAuth: true,
			title: 'MarketMath Airbnb Data',
			breadcrumb: [
				Breadcrumbs.Airbnb,
				Breadcrumbs.AirbnbListings,
			],
		},
	},

	{
		path: '/marketairbnb/:market/listings/:listing',
		name: 'market-airbnb-listing',
		component: AirbnbListing,
		meta: {
			requiresAuth: true,
			title: 'MarketMath Airbnb Data',
			breadcrumb: [
				Breadcrumbs.Airbnb,
				Breadcrumbs.AirbnbListings,
				Breadcrumbs.AirbnbListing,
			],
		},
	},

	{
		path: '/marketmanagers',
		name: 'marketmanagers',
		component: Managers,
		meta: {
			requiresAuth: true,
			title: 'MarketMath Managers',
			breadcrumb: [
				Breadcrumbs.Managers,
			],
		},
	},
	{
		path: '/marketmanagers/:manager',
		name: 'marketmanager',
		component: Manager,
		meta: {
			requiresAuth: true,
			title: 'MarketMath Managers',
			breadcrumb: [
				Breadcrumbs.Managers,
				Breadcrumbs.Manager,
			],
		},
	},

	{
		path: '/marketsponsors',
		name: 'marketsponsors',
		component: Sponsors,
		meta: {
			requiresAuth: true,
			title: 'MarketMath Sponsors',
			breadcrumb: [
				Breadcrumbs.Sponsors,
			],
		},
	},
	{
		path: '/marketsponsors/:sponsor',
		name: 'marketsponsor',
		component: Sponsor,
		meta: {
			requiresAuth: true,
			title: 'MarketMath Sponsors',
			breadcrumb: [
				Breadcrumbs.Sponsors,
				Breadcrumbs.Sponsor,
			],
		},
	},
]
